package com.bikompanion.ui.home

/**
 * The screen a rider is looking at, as reported to analytics.
 *
 * Settings is an overlay rather than a route, so it wins over whatever route sits under it.
 */
internal fun HomeViewModel.State.analyticsScreenName(): String =
    settingsPage?.let { "Settings${it.name}" }
        ?: when (backStack.lastOrNull()) {
            is StationRoute -> "Station"
            MapRoute, null -> "Map"
        }
